import React from 'react';
import { connect } from 'react-redux';
import SingleLoading from "./SingleLoading";

function Loading(props) {
  return (
    props.oShared.bLoading ?
      <SingleLoading /> : null
  )
}

const mapStateToProps = oState => ({
  oShared: oState.SharedReducer,
})

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Loading);
